module.exports = __webpack_public_path__ + "assets/img/tx388_3.516b71fd.jpg";